<template>
  <form-section :title="$t('NotificationLog_Deliveries')">
    <rest-list :payload="fetchEndpoint" :outline="false">
      <rest-list-column
        prop="profile_id"
        :title="$t('NotificationLog_Delivery_Profile')"
        :route="$can('UserData::ReadAccess') ? profileIdRoute : null"
        :width="300"
      />

      <rest-list-column
        v-if="showDeviceId"
        prop="device_id"
        :title="$t('NotificationLog_Delivery_Device')"
        :route="$can('Device::Read') ? deviceIdRoute : null"
        :width="180"
      />

      <rest-list-column-boolean
        v-if="showPending"
        :title="$t('NotificationLog_Delivery_Pending')"
        prop="pending"
        :width="180"
      />

      <rest-list-column
        :title="$t('NotificationLog_Delivery_Context')"
        prop="context"
      />

      <rest-list-column-date
        prop="create_time"
        :title="$t('NotificationLog_Delivery_Date')"
        :width="180"
      />
    </rest-list>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import RestListColumnBoolean from '@/common/components/rest/RestListColumnBoolean'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import { MessageTypeEnum } from '@/common/enum/MessageTypeEnum'

export default {
  name: 'NotificationDeliveries',

  components: {
    RestListColumnBoolean,
    FormSection,
    RestList,
    RestListColumn,
    RestListColumnDate
  },

  props: {
    model: {
      required: true
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `actions/${this.$route.query.id}/deliveries`
      })
    },

    showDeviceId() {
      return !(
        this.model.message_type === MessageTypeEnum.EMAIL ||
        this.model.message_type === MessageTypeEnum.SMS ||
        this.model.message_type === MessageTypeEnum.WHATSAPP ||
        (this.model.message_type === MessageTypeEnum.INBOX &&
          this.features.inboxProfileOn)
      )
    },

    showPending() {
      return (
        this.model.send_mode === 10 &&
        (this.model.message_type === MessageTypeEnum.ON_SITE ||
          this.model.message_type === MessageTypeEnum.IN_APP)
      )
    }
  },

  methods: {
    profileIdRoute(row) {
      return projectRoute({
        name: 'ProfileOverview',
        query: {
          profile_id: row.profile_id
        }
      })
    },

    deviceIdRoute(row) {
      return projectRoute({
        name: 'Device',
        query: { device_id: row.device_id }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/notifications-log/components/NotificationDeliveries.vue